import React, { useMemo } from 'react';
import { Shop } from '@box-types';
import {
  getShopRating,
  getFormattedShopRating,
  formatReviewsCounter,
  getShopRatingStatus,
  ShopRatingStatus
} from '@box/utils';

type ShopRatingProps = {
  shop: Shop;
  showCounter?: boolean;
};

const ShopRating: React.FC<ShopRatingProps> = ({ shop, showCounter = false }) => {
  // useMemo is used to avoid recalculating derived values unless shop changes
  const rating = useMemo(() => getShopRating(shop), [shop]);
  const ratingText = useMemo(() => getFormattedShopRating(shop), [shop]);
  const ratingCounterText = useMemo(() => formatReviewsCounter(shop.ratingCounter), [shop]);
  const status: ShopRatingStatus = useMemo(() => getShopRatingStatus(shop), [shop]);

  const ratingClass = useMemo(() => {
    switch (status) {
      case 'EXCELLENT':
        return 'shop-rating-component shop-rating-component-excellent';
      case 'GOOD':
        return 'shop-rating-component shop-rating-component-good';
      case 'OK':
        return 'shop-rating-component shop-rating-component-ok';
      default:
        return 'shop-rating-component';
    }
  }, [status]);

  return (
    <div className={ratingClass}>
      <span className="shop-rating-component-icon material-icons">star</span>
      <span className="shop-rating-component-content ods-typography-microcopy-bold">{ratingText}</span>
      {showCounter && rating > 0 && (
        <span className="shop-rating-component-counter ods-typography-microcopy-regular">({ratingCounterText})</span>
      )}
    </div>
  );
};

export default React.memo(ShopRating, (prev, next) => {
  return prev.shop._id === next.shop._id;
});
